import { IApplicationState } from '../../../types/redux';

/**
 * Выбирает статус тэгов
 */
export const selectTagsStatus = ({ tagsNew }: IApplicationState) => tagsNew.status;
